DeviceManager.Internal.ExternalDisplay = {};
